export class Upload {

  $key?:string;
  file?:File;
  photoName?: string;
  description?: string;
  facebook?:boolean;
  instagram?: boolean;
  advertisement?: boolean;
  autre?: boolean;
  name?: string;
  shortname?: string;
  username?: string;
  background?: string;
  commentsCount?: number;
  thumbnail?: string;
  uid: string;
  url?: string;
  progress?: number;
  lastModified?: number;
  published: boolean;
  commented: boolean;
  hold: boolean;
  storyTelling: boolean;
  archived: boolean;
  createdAt: number = new Date().getTime();
  //lastModifiedDate: Date = new Date();
  constructor(file:any, user: any ) {
    this.file = file.file;
    this.url = file.url;
    this.description = file.file.name || '';
    this.thumbnail = 'thumb_' + file.file.name;
    this.shortname = file.file.name;
    this.lastModified = file.file.lastModified;
    this.published = false;
    this.commented = true;
    this.hold = false;
    this.storyTelling = false;
    this.archived = false;
    this.createdAt = new Date().getTime();
    this.username = user.displayName;
    this.commentsCount=0;
    this.background = user.background;
  //  let fileExtension = '.' + this.file.name.split('.').pop();
    this.name = Math.random().toString(36).substring(7) + new Date().getTime(); //+ fileExtension;
  }
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/upload.ts